export default {
    en: {
        user_guide_title:"PM AUTOTWIN Quick Start Guide",

        user_guide_1_title:"1. Upload File ",
        user_guide_1_desc:"Drag and drop or click to upload your 3D model",
        
        user_guide_2_title:"2. Optimize ",
        user_guide_2_desc:"Review your uploaded model, set your preferred optimization level and output format, then start optimization",

        user_guide_3_title:"3. Review Results and Manage ",
        user_guide_3_desc:"Compare before and after results and download your file View your optimization history in the dashboard",

        user_guide_more:"View Full Guide →",
    },
    ko: {
        user_guide_title:"PM AUTOTWIN 시작 가이드",

        user_guide_1_title:"1. 파일 업로드 ",
        user_guide_1_desc:"드래그하거나 클릭해서 3D 모델을 업로드하세요",
        
        user_guide_2_title:"2. 최적화",
        user_guide_2_desc:"업로드한 모델을 확인한 후, 원하는 최적화 레벨과 출력 포맷을 설정하고 최적화를 시작하세요",

        user_guide_3_title:"3. 결과 확인 및 관리 ",
        user_guide_3_desc:"최적화 전후를 비교하고 파일을 다운로드하세요\n대시보드에서 최적화 내역을 확인할 수 있습니다",

        user_guide_more:"자세히 보기 →",
    },
    ja: {
        user_guide_title:"PM AUTOTWIN スタートガイド",

        user_guide_1_title:"1. ファイルアップロード",
        user_guide_1_desc:"ドラッグまたはクリックして3Dモデルをアップロードしてください",
        
        user_guide_2_title:"2. 最適化",
        user_guide_2_desc:"アップロードしたモデルを確認後、お好みの最適化レベルと出力フォーマットを設定して最適化を開始してください",

        user_guide_3_title:"3. 結果確認と管理",
        user_guide_3_desc:"最適化前後を比較し、ファイルをダウンロードしてください。\nダッシュボードで最適化履歴を確認できます。",

        user_guide_more:"詳しく見る →",
    },
};
